import http from '@/services/http';
import { offersFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const offers = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(filterStatus, offersFilters);
    return http.request({
      method: 'get',
      url: '/offers',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, offersFilters);
    return http.request({
      method: 'get',
      url: '/offers/count',
      params: { where },
      ...config,
    });
  },
  itemsIndex(id) {
    const where = {
      include: [{ relation: 'analysis' }],
    };
    return http.request({
      method: 'get',
      url: `/offers/${id}/offer-items`,
      params: { filter: where },
    });
  },
};

export default offers;
